export const CONVERSATION_COST_STATISTICS_UNITS = {
  input_tokens: 'Input token',
  output_tokens: 'Output token',
  tts_characters_count: 'TTS characters count',
};
